import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';

import { defaultPUR1021_R01HeaderDto, defaultPUR1021_R01PurchaseDto, defaultPUR1021_R01SuppliedDto, PUR1021_R01HeaderDto, PUR1021_R01PurchaseDto, PUR1021_R01SuppliedDto } from './Dto_PUR1021_R01';

export interface PUR1021_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	logicCenter: string;
	itemGroup: string;
	brandCd: string;
	customNm: string;
	customCd: string;
	itemCd: string;
	itemNm: string;
}
export interface Store_PUR1021_R01 {
    PUR1021_R01Filter: PUR1021_R01Filter;
    PUR1021_R01PastFilter: PUR1021_R01Filter;
    setPUR1021_R01Filter: (filter: Partial<Store_PUR1021_R01['PUR1021_R01Filter']>) => void;
    setPUR1021_R01PastFilter: (filter: Store_PUR1021_R01['PUR1021_R01PastFilter']) => void;

	

	// ====== 리스트 및 선택/편집 ======
    PUR1021_R01List: PUR1021_R01HeaderDto[];
    setPUR1021_R01List: (dataList: PUR1021_R01HeaderDto[]) => void;

    selectedPUR1021_R01: PUR1021_R01HeaderDto | undefined;
    setSelectedPUR1021_R01: (data: PUR1021_R01HeaderDto | undefined) => void;
    initSelectedPUR1021_R01: () => void;

	// ====== 리스트 및 선택/편집 ======
    deletedPUR1021_R01PurchaseList: string[];
    setDeletedPUR1021_R01PurchaseList: (idList: string[]) => void;
    addDeletedPUR1021_R01PurchaseList: (idList: string[]) => void;
    removeDeletedPUR1021_R01PurchaseList: (idList?: string[]) => void;

	// ====== 상세(lot) 데이터 ======
    PUR1021_R01PurchaseList: PUR1021_R01PurchaseDto[];
    setPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[]) => void;
    insertPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[], index?: number) => void;
    removePUR1021_R01PurchaseList: (index: number) => void;
    updatePUR1021_R01PurchaseList: (index: number, data: PUR1021_R01PurchaseDto) => void;

	// ====== 행 선택/삭제 관리 ======
    selectedPUR1021_R01PurchaseList: string[];
    setSelectedPUR1021_R01PurchaseList: (idList: string[]) => void;
    addSelectedPUR1021_R01PurchaseList: (idList: string[]) => void;
    removeSelectedPUR1021_R01PurchaseList: (idList?: string[]) => void;
    initSelectedPUR1021_R01PurchaseList: () => void;

    originalPUR1021_R01PurchaseList: PUR1021_R01PurchaseDto[];
    setOriginalPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[]) => void;

	// ====== 리스트 및 선택/편집 ======
    deletedPUR1021_R01SuppliedList: string[];
    setDeletedPUR1021_R01SuppliedList: (idList: string[]) => void;
    addDeletedPUR1021_R01SuppliedList: (idList: string[]) => void;
    removeDeletedPUR1021_R01SuppliedList: (idList?: string[]) => void;

	// ====== 상세(lot) 데이터 ======
    PUR1021_R01SuppliedList: PUR1021_R01SuppliedDto[];
    setPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[]) => void;
    insertPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[], index?: number) => void;
    removePUR1021_R01SuppliedList: (index: number) => void;
    updatePUR1021_R01SuppliedList: (index: number, data: PUR1021_R01SuppliedDto) => void;

	// ====== 행 선택/삭제 관리 ======
    selectedPUR1021_R01SuppliedList: string[];
    setSelectedPUR1021_R01SuppliedList: (idList: string[]) => void;
    addSelectedPUR1021_R01SuppliedList: (idList: string[]) => void;
    removeSelectedPUR1021_R01SuppliedList: (idList?: string[]) => void;
    initSelectedPUR1021_R01SuppliedList: () => void;

    originalPUR1021_R01SuppliedList: PUR1021_R01SuppliedDto[];
    setOriginalPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[]) => void;	

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	purchaseColumnState: ColumnState[] | null;
	setPurchaseColumnState: (state: ColumnState[] | null) => void;
	suppliedColumnState: ColumnState[] | null;
	setSuppliedColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	purchaseScrollTop: number | null;
	setPurchaseScrollTop: (top: number | null) => void;
	suppliedScrollTop: number | null;
	setSuppliedScrollTop: (top: number | null) => void;
	

	// ====== 초기??======
	initData: () => void;

}

export const defaultPUR1021_R01Filter : PUR1021_R01Filter = {
	compCd: '',
	dateRange: getCurrentMonthDateRange(), 
	logicCenter: '',
	itemGroup: '',
	brandCd: '',
	customCd: '',
	customNm: '',
	itemCd: '',
	itemNm: '',
};

export const usePUR1021_R01Store = create<Store_PUR1021_R01>((set) => ({
    PUR1021_R01Filter: defaultPUR1021_R01Filter,
    PUR1021_R01PastFilter: defaultPUR1021_R01Filter,
    setPUR1021_R01Filter: (update) => set((state) => ({
        PUR1021_R01Filter: {
            ...state.PUR1021_R01Filter,
            ...update
        }
    })),
    setPUR1021_R01PastFilter: (filter: Store_PUR1021_R01['PUR1021_R01PastFilter']) => set((state) => {
		return {
			...state,
			PUR1021_R01PastFilter: filter
		}
	}),

	// ====== 견적 리스??�??�택/?�집 ======
    PUR1021_R01List: [],
    setPUR1021_R01List: (dataList: PUR1021_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PUR1021_R01List: dataList
		}
	}),

    selectedPUR1021_R01: undefined,
	// 매출 선택 기능
    setSelectedPUR1021_R01: (data: PUR1021_R01HeaderDto | undefined) => set((state) => {
		let editData = null;
		if (data) {
			editData = { ...data };
		}
        return { selectedPUR1021_R01: data, editPUR1021_R01: editData, purchaseScrollTop: null, suppliedScrollTop: null };
	}),
    initSelectedPUR1021_R01: () => set({ selectedPUR1021_R01: undefined, PUR1021_R01PurchaseList: [] }),

	// ====== 견적 세(디테일) 데이터======
    PUR1021_R01PurchaseList: [],
    setPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
            PUR1021_R01PurchaseList: newList
		};
	}),
    insertPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[], index?: number) => set((state) => {
        const newPUR1021_R01PurchaseList = [...state.PUR1021_R01PurchaseList];

		//let valueIndex = newSYS4100_R01List.length + 1;
        let valueIndex = Math.max(0, ...newPUR1021_R01PurchaseList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex가 있는 것들 중에서 orderIndexSeq 값을 찾는다
        const maxOrderIndexSeq = Math.max(0, ...newPUR1021_R01PurchaseList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
        const newData = data.map(item => ({ ...defaultPUR1021_R01PurchaseDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
            newPUR1021_R01PurchaseList.splice(index, 0, ...newData);
		} else {
            newPUR1021_R01PurchaseList.push(...newData);
		}
		return {
			...state,
            PUR1021_R01PurchaseList: newPUR1021_R01PurchaseList
		}
	}),
    removePUR1021_R01PurchaseList: (index: number) => set((state) => {
        const newPUR1021_R01PurchaseList = [...state.PUR1021_R01PurchaseList].filter((item) => item.valueIndex !== index);
		return {
			...state,
            PUR1021_R01PurchaseList: newPUR1021_R01PurchaseList
		}
	}),
    updatePUR1021_R01PurchaseList: (valueIndex: number, data: PUR1021_R01PurchaseDto) => set((state) => {
        const _PUR1021_R01PurchaseList = state.PUR1021_R01PurchaseList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
            PUR1021_R01PurchaseList: _PUR1021_R01PurchaseList
		}
	}),
	
	// ====== 행삭제 테이블(품목테이블)======
    deletedPUR1021_R01PurchaseList: [],
    setDeletedPUR1021_R01PurchaseList: (idList: string[]) => set((state) => {
		return {
			...state,
            deletedPUR1021_R01PurchaseList: idList
		}
	}),
    addDeletedPUR1021_R01PurchaseList: (idList: string[]) => set((state) => {
        const _deletedPurchaseList = [...state.deletedPUR1021_R01PurchaseList];

        for(const valueIndex of idList) {
            const isInserted = state.PUR1021_R01PurchaseList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
            const isModified = state.PUR1021_R01PurchaseList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedPurchaseList.push(valueIndex);
			}
		}
		
		return {
			...state,
            deletedPUR1021_R01PurchaseList: _deletedPurchaseList
		}
	}),
    removeDeletedPUR1021_R01PurchaseList: (idList?: string[]) => set((state) => ({
		...state,
        deletedPUR1021_R01PurchaseList: [...state.deletedPUR1021_R01PurchaseList].filter(value => idList ? !idList.includes(value) : false)
	})),

    selectedPUR1021_R01PurchaseList: [],
    setSelectedPUR1021_R01PurchaseList: (idList: string[]) => set((state) => {
		return {
			...state,
            selectedPUR1021_R01PurchaseList: idList
		}
	}),
    addSelectedPUR1021_R01PurchaseList: (idList: string[]) => set((state) => {
        const _selectedPUR1021_R01PurchaseList = [...state.selectedPUR1021_R01PurchaseList];
		if(idList.length > 0) {
            _selectedPUR1021_R01PurchaseList.push(...idList);
		}
		return {
			...state,
            selectedPUR1021_R01PurchaseList: _selectedPUR1021_R01PurchaseList
		}
	}),
    removeSelectedPUR1021_R01PurchaseList: (idList?: string[]) => set((state) => ({
		...state,
        selectedPUR1021_R01PurchaseList: [...state.selectedPUR1021_R01PurchaseList].filter(value => idList ? !idList.includes(value) : false)
	})),
    initSelectedPUR1021_R01PurchaseList: () => set({ selectedPUR1021_R01PurchaseList: [] }),

    originalPUR1021_R01PurchaseList: [],
    setOriginalPUR1021_R01PurchaseList: (data: PUR1021_R01PurchaseDto[]) => set((state) => {
        let newList: PUR1021_R01PurchaseDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
                ...defaultPUR1021_R01PurchaseDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
            originalPUR1021_R01PurchaseList: newList
		}
	}),

			// ====== 견적 세(디테일) 데이터======
			PUR1021_R01SuppliedList: [],
			setPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[]) => set((state) => {
				const newList = data.map((item, index) => ({
					...item,
					valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
					orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
					orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
				}));
				
				return {
					...state,
					PUR1021_R01SuppliedList: newList
				};
			}),
			insertPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[], index?: number) => set((state) => {
				const newPUR1021_R01SuppliedList = [...state.PUR1021_R01SuppliedList];
		
				//let valueIndex = newSYS4100_R01List.length + 1;
				let valueIndex = Math.max(0, ...newPUR1021_R01SuppliedList.map(item => item.valueIndex || 0)) + 1;
				let targetOrderIndex = index ? index : 1;
				// 같은 orderIndex가 있는 것들 중에서 orderIndexSeq 값을 찾는다
				const maxOrderIndexSeq = Math.max(0, ...newPUR1021_R01SuppliedList
					.filter(item => item.orderIndex === targetOrderIndex)
					.map(item => item.orderIndexSeq || 0)
				);
				let targetOrderIndexSeq = maxOrderIndexSeq + 1;
				// console.log('valueIndex : ', valueIndex 
				// 				+ ' 멤버 index : ' + index
				// 				+ ' 최종 orderIndex : ' + targetOrderIndex
				// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
				// 			);
				
				const newData = data.map(item => ({ ...defaultPUR1021_R01SuppliedDto, ...item, 
					valueIndex: valueIndex++,
					orderIndex: targetOrderIndex,
					orderIndexSeq: targetOrderIndexSeq
				}));
				if (index !== undefined) {
					newPUR1021_R01SuppliedList.splice(index, 0, ...newData);
				} else {
					newPUR1021_R01SuppliedList.push(...newData);
				}
				return {
					...state,
					PUR1021_R01SuppliedList: newPUR1021_R01SuppliedList
				}
			}),
			removePUR1021_R01SuppliedList: (index: number) => set((state) => {
				const newPUR1021_R01SuppliedList = [...state.PUR1021_R01SuppliedList].filter((item) => item.valueIndex !== index);
				return {
					...state,
					PUR1021_R01SuppliedList: newPUR1021_R01SuppliedList
				}
			}),
			updatePUR1021_R01SuppliedList: (valueIndex: number, data: PUR1021_R01SuppliedDto) => set((state) => {
				const _PUR1021_R01SuppliedList = state.PUR1021_R01SuppliedList.map(item =>
					item.valueIndex === valueIndex ? data : item
				);
				return {
					...state,
					PUR1021_R01SuppliedList: _PUR1021_R01SuppliedList
				}
			}),
			
			// ====== 행삭제 테이블(품목테이블)======
			deletedPUR1021_R01SuppliedList: [],
			setDeletedPUR1021_R01SuppliedList: (idList: string[]) => set((state) => {
				return {
					...state,
					deletedPUR1021_R01SuppliedList: idList
				}
			}),
			addDeletedPUR1021_R01SuppliedList: (idList: string[]) => set((state) => {
				const _deletedSuppliedList = [...state.deletedPUR1021_R01SuppliedList];
		
				for(const valueIndex of idList) {
					const isInserted = state.PUR1021_R01SuppliedList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
					const isModified = state.PUR1021_R01SuppliedList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
					if(!isInserted && !isModified) {
						_deletedSuppliedList.push(valueIndex);
					}
				}
				
				return {
					...state,
					deletedPUR1021_R01SuppliedList: _deletedSuppliedList
				}
			}),
			removeDeletedPUR1021_R01SuppliedList: (idList?: string[]) => set((state) => ({
				...state,
				deletedPUR1021_R01SuppliedList: [...state.deletedPUR1021_R01SuppliedList].filter(value => idList ? !idList.includes(value) : false)
			})),
		
			selectedPUR1021_R01SuppliedList: [],
			setSelectedPUR1021_R01SuppliedList: (idList: string[]) => set((state) => {
				return {
					...state,
					selectedPUR1021_R01SuppliedList: idList
				}
			}),
			addSelectedPUR1021_R01SuppliedList: (idList: string[]) => set((state) => {
				const _selectedPUR1021_R01SuppliedList = [...state.selectedPUR1021_R01SuppliedList];
				if(idList.length > 0) {
					_selectedPUR1021_R01SuppliedList.push(...idList);
				}
				return {
					...state,
					selectedPUR1021_R01SuppliedList: _selectedPUR1021_R01SuppliedList
				}
			}),
			removeSelectedPUR1021_R01SuppliedList: (idList?: string[]) => set((state) => ({
				...state,
				selectedPUR1021_R01SuppliedList: [...state.selectedPUR1021_R01SuppliedList].filter(value => idList ? !idList.includes(value) : false)
			})),
			initSelectedPUR1021_R01SuppliedList: () => set({ selectedPUR1021_R01SuppliedList: [] }),
		
			originalPUR1021_R01SuppliedList: [],
			setOriginalPUR1021_R01SuppliedList: (data: PUR1021_R01SuppliedDto[]) => set((state) => {
				let newList: PUR1021_R01SuppliedDto[] = [];
				let valueAndOrderIndex = 1;
				data.forEach((item, index) => {
					newList.push({ 
						...defaultPUR1021_R01SuppliedDto,
						...item,
						valueIndex: valueAndOrderIndex,
						orderIndex: valueAndOrderIndex,
						orderIndexSeq: valueAndOrderIndex
					});
					valueAndOrderIndex++;
				});
				return {
					...state,
					originalPUR1021_R01SuppliedList: newList
				}
			}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	purchaseColumnState: null,
	setPurchaseColumnState: (state: ColumnState[] | null) => set({ purchaseColumnState: state }),
	suppliedColumnState: null,
	setSuppliedColumnState: (state: ColumnState[] | null) => set({ suppliedColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	purchaseScrollTop: null,
	setPurchaseScrollTop: (top: number | null) => set({ purchaseScrollTop: top }),
	suppliedScrollTop: null,
	setSuppliedScrollTop: (top: number | null) => set({ suppliedScrollTop: top }),
						

	// ====== 초기화======
    initData: () => set((state) => ({
		...state,
        PUR1021_R01Filter: defaultPUR1021_R01Filter,
        PUR1021_R01PastFilter: defaultPUR1021_R01Filter,
        PUR1021_R01List: [],
        selectedPUR1021_R01: undefined,
        PUR1021_R01PurchaseList: [],
        deletedPUR1021_R01PurchaseList: [],
        selectedPUR1021_R01PurchaseList: [],
        originalPUR1021_R01PurchaseList: [],
		PUR1021_R01SuppliedList: [],
		deletedPUR1021_R01SuppliedList: [],
		selectedPUR1021_R01SuppliedList: [],
		originalPUR1021_R01SuppliedList: [],
        editPUR1021_R01: defaultPUR1021_R01HeaderDto,
		allCount: 0,
		
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		purchaseScrollTop: null,
		suppliedScrollTop: null,
	})),

	
}));
